import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';

/**
 * Initialize Capacitor and configure platform-specific settings
 */
export const initCapacitor = () => {
  const isNative = Capacitor.isNativePlatform();
  const platform = Capacitor.getPlatform();

  console.log('Capacitor initialized:', {
    platform,
    isNative,
  });

  // Platform-specific initializations
  if (isNative) {
    // Disable iOS rubber-band effect
    if (platform === 'ios') {
      document.body.style.overflow = 'hidden';
    }

    // Add platform class to body for platform-specific styling
    document.body.classList.add(`platform-${platform}`);

    // Initialize app lifecycle listeners
    initAppLifecycle();
  } else {
    document.body.classList.add('platform-web');
  }

  return {
    platform,
    isNative,
  };
};

/**
 * Initialize App Lifecycle listeners
 * Note: Tokens are now stored persistently in Capacitor Preferences
 * and should NOT be cleared when app goes to background
 */
const initAppLifecycle = () => {
  // Listen for app state changes (for logging/debugging only)
  App.addListener('appStateChange', ({ isActive }) => {
    console.log('App state changed. Is active:', isActive);
    // Tokens werden NICHT gelöscht - sie sind persistent in Capacitor Preferences gespeichert
  });

  // Listen for app pause (for logging/debugging only)
  App.addListener('pause', () => {
    console.log('App paused');
    // Tokens werden NICHT gelöscht - Benutzer soll eingeloggt bleiben
  });

  console.log('App lifecycle listeners initialized');
};

/**
 * Get the correct API URL based on platform
 */
export const getApiUrl = () => {
  const isNative = Capacitor.isNativePlatform();

  // In native apps, use the actual server URL
  // In web, use relative URLs or environment variable
  if (isNative) {
    // For development: use your computer's local IP
    // For production: use your production API URL
    return process.env.REACT_APP_API_URL || 'http://10.0.2.2:86/api/v1';
  }

  return process.env.REACT_APP_API_URL || '/api/v1';
};
